import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import OrderDashboardPanelHeader from '../../OrderDashboard/parts/PanelHeader';

class PanelHeader extends React.Component {
  render() {
    return (
      <OrderDashboardPanelHeader
        {...this.props}
      />
    )
  }
}

PanelHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isDemo: PropTypes.bool,
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dateRanges: PropTypes.object,
  dateSelected: PropTypes.object,
  handleSelectDate: PropTypes.func,
  togglePlanDialog: PropTypes.func,
  showUpdateDate: PropTypes.bool,
  keyword: PropTypes.string,
  handleChangeKeyword: PropTypes.func,
  handleSearch: PropTypes.func,
};

PanelHeader.defaultProps = {
  showUpdateDate: true,
};

const mapStateToProps = (state) => {
  return {
    isDemo: state.accountSetting.showDemoData,
  };
};

export default withStyles()(connect(
  mapStateToProps
)(PanelHeader));



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/parts/PanelHeader.jsx